import React from 'react';
import { StyledCaptureCollabIcon } from '../../../assets/CaptureCollabIconSVG';
import { SmartContainer } from '../../../styles/Containers';
import { StyledCircularProgress } from '../../../styles/matieralui/Progress';
export const FullScreenLoader = () => {
    return (
        <SmartContainer minHeight="100vh" width="100%" flex align="center" justify="center">
            <StyledCaptureCollabIcon />
        </SmartContainer>
    )
}